import VideoService from '@/services/VideoService';
import UserService from '@/services/UserService';
export default {
  props: {
    video: {
      type: Object,
      default() {
        return {};
      }
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      showInfo: 0,
      videolink: '',
      favoriteLoading: false,
      localFavorite: false
    };
  },
  watch: {
    'video.favorite': {
      immediate: true,
      handler(val) {
        this.localFavorite = !!val;
      }
    }
  },
  methods: {
    async favorite() {
      if (this.favoriteLoading) return;
      this.favoriteLoading = true;
      try {
        await VideoService.favorite(this.video.id);
        const newState = !this.localFavorite;
        this.localFavorite = newState;
        this.$emit('update-video-favorite-status', {
          id: this.video.id,
          favorite: newState,
          video: this.video
        });
      } catch (e) {
        console.error('Failed to update favorite. Please try again.');
      } finally {
        this.favoriteLoading = false;
      }
    },
    copy() {
      const el = document.createElement('textarea');
      el.style.position = 'fixed';
      el.style.opacity = 0;
      el.textContent = decodeURI(this.videolink);
      const body = document.getElementsByTagName('body')[0];
      body.appendChild(el);
      el.select();
      document.execCommand('copy');
      body.removeChild(el);
    },
    async getVideolink() {
      const network = await UserService.getNetworkInfo();
      this.videolink = network.url + '/video/watch/' + this.video.id;
    }
  },
  computed: {
    sharedTags() {
      if (this.video.video.sharedTag.length > 6) {
        return this.video.video.sharedTag.slice(0, 6);
      }
      return this.video.video.sharedTag;
    }
  },
  filters: {
    stringMax(val, amount) {
      let str = val;
      if (val.length > amount + 3) {
        str = val.substr(0, amount) + '...';
      }
      return str;
    }
  },
  mounted() {
    this.getVideolink();
  }
};